import clsx from 'clsx'
import {useEffect, useRef} from 'react'
import {ILayout, useLayout} from '../../core'
import {SidebarMenu} from './sidebar-menu/SidebarMenu'
import {SidebarFooter} from './SidebarFooter'
import {SidebarLogo} from './SidebarLogo'

const Sidebar = () => {
  const {config} = useLayout()
  const sidebarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    updateDOM(config)
  }, [config])

  if (!config.app?.sidebar?.display) {
    return null
  }

  console.log(config.layoutType)

  return (
    <>
      {(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
        <div
          ref={sidebarRef}
          id='kt_app_sidebar'
          className={clsx('app-sidebar', config.app?.sidebar?.default?.class)}
          style={{
            backgroundColor: '#0F323D',
          }}
        >
          <SidebarLogo sidebarRef={sidebarRef} />
          <SidebarMenu />
          <SidebarFooter />
        </div>
      )}
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.layoutType !== 'dark-sidebar' && config.layoutType !== 'light-sidebar') {
    return
  }

  const body = document.body

  /* ========== MINIMIZE DESKTOP ========== */
  if (config.app?.sidebar?.default?.minimize?.desktop?.enabled) {
    if (config.app?.sidebar?.default?.minimize?.desktop?.default) {
      body.setAttribute('data-kt-app-sidebar-minimize', 'on')
    } else {
      body.removeAttribute('data-kt-app-sidebar-minimize')
    }
  }

  /* ========== MINIMIZE MOBILE ========== */
  if (config.app?.sidebar?.default?.minimize?.mobile?.enabled) {
    if (config.app?.sidebar?.default?.minimize?.mobile?.default) {
      body.setAttribute('data-kt-app-sidebar-minimize-mobile', 'on')
    } else {
      body.removeAttribute('data-kt-app-sidebar-minimize-mobile')
    }
  }

  /* ❌ DISABLE ALL HOVERABLE BEHAVIOR */
  body.removeAttribute('data-kt-app-sidebar-hoverable')
  body.removeAttribute('data-kt-app-sidebar-hoverable-mobile')

  /* ========== COLLAPSE ========== */
  if (config.app?.sidebar?.default?.collapse?.desktop?.enabled) {
    if (config.app?.sidebar?.default?.collapse?.desktop?.default) {
      body.setAttribute('data-kt-app-sidebar-collapse', 'on')
    }
  }

  if (config.app?.sidebar?.default?.collapse?.mobile?.enabled) {
    if (config.app?.sidebar?.default?.collapse?.mobile?.default) {
      body.setAttribute('data-kt-app-sidebar-collapse-mobile', 'on')
    }
  }

  /* ========== PUSH OPTIONS ========== */
  if (config.app?.sidebar?.default?.push?.header) {
    body.setAttribute('data-kt-app-sidebar-push-header', 'true')
  }
  if (config.app?.sidebar?.default?.push?.toolbar) {
    body.setAttribute('data-kt-app-sidebar-push-toolbar', 'true')
  }
  if (config.app?.sidebar?.default?.push?.footer) {
    body.setAttribute('data-kt-app-sidebar-push-footer', 'true')
  }

  /* ========== ENABLE SIDEBAR ========== */
  body.setAttribute('data-kt-app-sidebar-enabled', 'true')
  body.setAttribute(
    'data-kt-app-sidebar-fixed',
    config.app?.sidebar?.default?.fixed?.desktop?.toString() || ''
  )

  const appSidebarDefaultDrawerEnabled = config.app?.sidebar?.default?.drawer?.enabled
  let appSidebarDefaultDrawerAttributes: {[attrName: string]: string} = {}
  if (appSidebarDefaultDrawerEnabled) {
    appSidebarDefaultDrawerAttributes = config.app?.sidebar?.default?.drawer?.attributes as {
      [attrName: string]: string
    }
  }

  const appSidebarDefaultStickyEnabled = config.app?.sidebar?.default?.sticky?.enabled
  let appSidebarDefaultStickyAttributes: {[attrName: string]: string} = {}
  if (appSidebarDefaultStickyEnabled) {
    appSidebarDefaultStickyAttributes = config.app?.sidebar?.default?.sticky?.attributes as {
      [attrName: string]: string
    }
  }

  setTimeout(() => {
    const sidebarElement = document.getElementById('kt_app_sidebar')
    // sidebar
    if (sidebarElement) {
      const sidebarAttributes = sidebarElement
        .getAttributeNames()
        .filter((t) => t.indexOf('data-') > -1)
      sidebarAttributes.forEach((attr) => sidebarElement.removeAttribute(attr))

      if (appSidebarDefaultDrawerEnabled) {
        for (const key in appSidebarDefaultDrawerAttributes) {
          if (appSidebarDefaultDrawerAttributes.hasOwnProperty(key)) {
            sidebarElement.setAttribute(key, appSidebarDefaultDrawerAttributes[key])
          }
        }
      }

      if (appSidebarDefaultStickyEnabled) {
        for (const key in appSidebarDefaultStickyAttributes) {
          if (appSidebarDefaultStickyAttributes.hasOwnProperty(key)) {
            sidebarElement.setAttribute(key, appSidebarDefaultStickyAttributes[key])
          }
        }
      }
    }
  }, 0)
}

export {Sidebar}
